// extracted by mini-css-extract-plugin
export default {"wrap":"wrap-eXUL","text":"text-V0Dk","icon":"icon-_mz8"};